export default function CountryFact({ category, value, externalLink }) {
  return (
    <li className="tw-pt-2">
      <strong className="tw-font-semibold">{category}</strong>{' '}
      {externalLink ? (
        <a
          rel="noopener noreferrer nofollow"
          target="_blank"
          href={externalLink}
        >
          {value}
        </a>
      ) : (
        value
      )}
    </li>
  );
}
